/*
  Generates constants for FAILURE, REQUEST, and SUCCESS given an set of constants

*/

export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';
export const REQUEST = 'REQUEST';

export default (...args) =>
  args.reduce(
    (acc, curr) => ({
      ...acc,
      [`${curr}_${FAILURE}`]: `${curr}_${FAILURE}`,
      [`${curr}_${SUCCESS}`]: `${curr}_${SUCCESS}`,
      [`${curr}_${REQUEST}`]: `${curr}_${REQUEST}`,
    }),
    {},
  );
